import styled from 'styled-components';

const hexToRgba = (hex: string, opacity: number) => {
  const bigint = parseInt(hex.slice(1), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const WrapperErrorAlert = styled.div`
    width: 100%;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.colors.error};
    background-color: ${({ theme }) => hexToRgba(theme.colors.error, 0.2)};
`;

export const ContainerTitle = styled.div`
    display: flex;
    height: 20px;
    align-items: center;
    align-content: flex-start;
    margin: 8px;
`;

export const ContainerInfo = styled.div`
    display: flex;
    align-items: center;
    align-content: flex-start;
    margin: 8px;
`;

export const InfoText = styled.span`
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    text-align: left;

`;

export const Title = styled.span`
    font-family: Inter;
    font-size: 14px;
    font-weight: 600;
    line-height: 16.94px;
    text-align: left;
    color: ${({ theme }) => theme.colors.error};
`;

export const Icon = styled.img`
    width: 16px;
    height: 16px;
    margin-right: 8px;

    &:hover {
        cursor: pointer;
    }
`;

export const ContainerLinkCopy = styled.div`
    height: 48px;
    padding: 0 16px;
    border-radius: 8px;
    border: 1px solid #C4CDD5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 8px;
    background-color: #fff;
`;

export const CopyLinkBtn = styled.button`
    background-color: transparent;
    line-height: 0;
    padding: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;

    &:hover {
        background-color: transparent;
    }

    & small {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 8px;
        color: #212B36;
        position: absolute;
        background-color: #fff;
        right: 1.4rem;
    }
`;
